import { createSlice } from "@reduxjs/toolkit";

const initialAlertsState = {
    filterResult: null,
}


const alertsSlice = createSlice({
    name: 'alerts',
    initialState: initialAlertsState,
    reducers: {
        setFilterResult(state, data) {
            state.filterResult = data.payload
        },
    }
})

export const alertsActions = alertsSlice.actions

export default alertsSlice.reducer